import React from "react";
import Box from "@mui/material/Box";

import { CheckboxWithLabel, Textfield } from "../../../components";

export function DonationMessage({ showMessageTextArea, handleInputChange }) {
    return <Box sx={{pt: 1}}>
        <CheckboxWithLabel label="Leave a message with your donation" nameAndId="leaveAMessageWithDonation" handleCheck={handleInputChange} />
        {showMessageTextArea &&
            <div id="goodluck_div">
                <Textfield
                    id="goodLuckMessage"
                    name="goodLuckMessage"
                    label="Your message"
                    onChange={handleInputChange}
                    margin="dense"
                    multiline
                    rows={4}
                    fullWidth />
                <span style={{ color: 'grey', fontSize: '11px' }}>max:500 char</span>
            </div>
        }
    </Box>
}